<template>
  <div class="navigation-editorial-cards">
    <a
      v-for="(item, index) in items"
      :key="`${item.url}-${index}`"
      :href="item.url"
      class="navigation-editorial-cards__card"
    >
      <div class="navigation-editorial-cards__media">
        <Media :images="item.images" cover eager />
      </div>
      <div class="navigation-editorial-cards__copy">
        <p v-if="item.title" class="navigation-editorial-cards__title">
          {{ item.title }}
        </p>
        <p
          v-if="item.description"
          class="navigation-editorial-cards__description"
        >
          {{ item.description }}
        </p>
      </div>
    </a>
  </div>
</template>

<script>
import Media from "@/components/Media.vue";

export default {
  name: "NavigationEditorialCards",
  components: {
    Media,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.navigation-editorial-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 552px;
  margin-left: auto;
  border-left: 1px solid #e4e4e4;
  padding-left: 20px;
}

.navigation-editorial-cards__card {
  display: grid;
  grid-template-columns: 151px minmax(0, 1fr);
  gap: 20px;
  align-items: start;
  text-decoration: none;
  color: inherit;

  &:last-child {
    margin-bottom: -1px;
  }
}

.navigation-editorial-cards__media {
  width: 151px;
  height: 101px;
  overflow: hidden;

  :deep(.wrapper),
  :deep(.media),
  :deep(picture),
  :deep(img),
  :deep(video) {
    display: block;
    width: 100%;
    height: 100%;
  }

  :deep(img),
  :deep(video) {
    object-fit: cover;
  }
}

.navigation-editorial-cards__copy {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.navigation-editorial-cards__title {
  margin: 0;
  @include editorial-body(14px);
  text-transform: uppercase;
  line-height: 1.4;
}

.navigation-editorial-cards__description {
  margin: 0;
  @include editorial-body(14px);
  line-height: 1.5;
  text-wrap: pretty;
}
</style>
